import { render, staticRenderFns } from "./modifiers.vue?vue&type=template&id=f3b31e7a"
import script from "./modifiers.vue?vue&type=script&lang=js"
export * from "./modifiers.vue?vue&type=script&lang=js"
import style0 from "./modifiers.vue?vue&type=style&index=0&id=f3b31e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports